import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faImage } from "@fortawesome/free-solid-svg-icons";

const base_url = process.env.REACT_APP_API_URL;

const WithdrawHistory = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [withdraw, setWithdraw] = useState([]);
  const [filteredWithdraw, setFilteredWithdraw] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);

  const [searchText, setSearchText] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [minAmount, setMinAmount] = useState("");
  const [maxAmount, setMaxAmount] = useState("");

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  function formateT(val) {
    return val < 10 ? "0" + val : val;
  }

  function timerJoin(time = "", addHours = 0) {
    let date = time ? new Date(Number(time)) : new Date();
    date.setHours(date.getHours() + addHours);
    const y = formateT(date.getFullYear());
    const m = formateT(date.getMonth() + 1);
    const d = formateT(date.getDate());
    const h = date.getHours() % 12 || 12;
    const ampm = date.getHours() < 12 ? "AM" : "PM";
    const min = formateT(date.getMinutes());
    const sec = formateT(date.getSeconds());

    return `${y}-${m}-${d} ${h}:${min}:${sec} ${ampm}`;
  }

  const withdrawData = async () => {
    try {
      const auth = localStorage.getItem("admin");
      const response = await axios.post(
        base_url + "/api/webapi/admin/recharge",
        { auth },
        { headers: { "content-type": "application/json" } }
      );

      const data = response?.data.datas4 || [];
      if (response?.data.status) {
        const formatted = data.map((item) => ({
          ...item,
          proof_image: item.proof_image?.startsWith("/")
            ? base_url + item.proof_image
            : item.proof_image || "/api/placeholder/400/300",
        }));
        setWithdraw(formatted);
        setFilteredWithdraw(formatted);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleImageClick = (img) => {
    setSelectedImage(img);
    setShowImageModal(true);
  };

  const closeImageModal = () => {
    setSelectedImage(null);
    setShowImageModal(false);
  };

  const resetFilters = () => {
    setSearchText("");
    setStatusFilter("");
    setFromDate("");
    setToDate("");
    setMinAmount("");
    setMaxAmount("");
  };

  useEffect(() => {
    withdrawData();
  }, [refresh]);

  useEffect(() => {
    const filtered = withdraw.filter((item) => {
      const matchesSearch =
        item.id_order?.toLowerCase().includes(searchText.toLowerCase()) ||
        item.phone?.toLowerCase().includes(searchText.toLowerCase());

      const matchesStatus =
        statusFilter === "" || String(item.status) === statusFilter;

      const itemDate = new Date(Number(item.time)).toISOString().slice(0, 10);
      const matchesFromDate = !fromDate || itemDate >= fromDate;
      const matchesToDate = !toDate || itemDate <= toDate;

      const money = parseFloat(item.money || 0);
      const matchesMinAmount = !minAmount || money >= parseFloat(minAmount);
      const matchesMaxAmount = !maxAmount || money <= parseFloat(maxAmount);

      return (
        matchesSearch &&
        matchesStatus &&
        matchesFromDate &&
        matchesToDate &&
        matchesMinAmount &&
        matchesMaxAmount
      );
    });

    setFilteredWithdraw(filtered);
  }, [searchText, statusFilter, fromDate, toDate, minAmount, maxAmount, withdraw]);


  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <div className="wrapper">
        {/* Main Sidebar */}
        <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        />
        
        {/* Header - Pass mobile info */}
        <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        />
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper d-flex flex-column ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
        <section className="content mt-2">
          <div className="d-flex justify-content-between flex-wrap p-2">
            <h3>Withdraw History</h3>
            <button
              className="btn btn-sm btn-primary"
              onClick={() => setRefresh(!refresh)}
            >
              Refresh
            </button>
          </div>

          {/* Filters */}
         {/* Filters */}
<div className="row mt-3">
  <div className="col-md-3 mb-3">
    <label className="form-label">Search</label>
    <input
      type="text"
      className="form-control"
      placeholder="Search by Phone or ID"
      value={searchText}
      onChange={(e) => setSearchText(e.target.value)}
    />
  </div>
  <div className="col-md-3 mb-3">
  <label className="form-label d-block">Status</label>
  <div className="btn-group w-100" role="group">
    <button
      type="button"
      className={`btn ${statusFilter === '' ? 'btn-secondary text-white' : 'btn-outline-secondary'}`}
      onClick={() => setStatusFilter('')}
    >
      All
    </button>
    <button
      type="button"
      className={`btn ${statusFilter === '1' ? 'btn-success text-white' : 'btn-outline-success'}`}
      onClick={() => setStatusFilter('1')}
    >
      Success
    </button>
    <button
      type="button"
      className={`btn ${statusFilter === '2' ? 'btn-danger text-white' : 'btn-outline-danger'}`}
      onClick={() => setStatusFilter('2')}
    >
      Rejected
    </button>
  </div>
</div>


  <div className="col-md-3 mb-3">
    <label className="form-label">From Date</label>
    <input
      type="date"
      className="form-control"
      value={fromDate}
      onChange={(e) => setFromDate(e.target.value)}
    />
  </div>
  <div className="col-md-3 mb-3">
    <label className="form-label">To Date</label>
    <input
      type="date"
      className="form-control"
      value={toDate}
      onChange={(e) => setToDate(e.target.value)}
    />
  </div>
  <div className="col-md-3 mb-3">
    <label className="form-label">Min Amount</label>
    <input
      type="number"
      className="form-control"
      placeholder="Min Amount"
      value={minAmount}
      onChange={(e) => setMinAmount(e.target.value)}
    />
  </div>
  <div className="col-md-3 mb-3">
    <label className="form-label">Max Amount</label>
    <input
      type="number"
      className="form-control"
      placeholder="Max Amount"
      value={maxAmount}
      onChange={(e) => setMaxAmount(e.target.value)}
    />
  </div>
  <div className="col-md-3 mb-3 align-self-end">
    <button className="btn btn-secondary w-100" onClick={resetFilters}>
      Reset Filters
    </button>
  </div>
</div>


          {/* Table */}
          <div className="table-responsive mt-3">
            <table className="table table-striped table-hover">
              <thead className="bg-dark text-white">
                <tr>
                  <th className="text-light">ID</th>
                  <th className="text-light">Account</th>
                  <th className="text-light">Bank</th>
                  <th className="text-light">Amount</th>
                  <th className="text-light">Transaction ID</th>
                  <th className="text-light">Proof</th>
                  <th className="text-light">Remarks</th>
                  <th className="text-light">Status</th>
                  <th className="text-light">Request Time</th>
                  <th className="text-light">Approval/Reject Time</th>

                </tr>
              </thead>
              <tbody>
                {filteredWithdraw.map((draw) => (
                  <tr key={draw.id}>
                    <td>{draw.id}</td>
                    <td>{draw.phone}</td>
                    <td>{draw.name_bank}</td>
                    <td>{draw.money}</td>
                    <td>{draw.id_order}</td>
                    <td className="text-center">
                      <button
                        className="btn btn-sm btn-info"
                        onClick={() => handleImageClick(draw.proof_image)}
                      >
                        <FontAwesomeIcon icon={faImage} />
                      </button>
                    </td>
                    <td>{draw.remarks}</td>
                    <td className="text-center">
                      <span
                        style={{
                          backgroundColor: draw.status === 1 ? "green" : "red",
                          color: "white",
                          padding: "5px 10px",
                          borderRadius: "0.5rem",
                        }}
                      >
                        {draw.status === 1 ? "Success" : "Reject"}
                      </span>
                    </td>
                    <td>{timerJoin(draw.time)}</td>
                    <td>{draw.approvaltime}</td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </div>

      {/* Image Modal */}
      {showImageModal && (
        <div className="modal show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Transaction Proof</h5>
                <button className="btn-close" onClick={closeImageModal}></button>
              </div>
              <div className="modal-body text-center">
                {selectedImage ? (
                  <img
                    src={selectedImage}
                    alt="Proof"
                    className="img-fluid"
                    style={{ maxHeight: "70vh" }}
                    onError={(e) => {
                      e.target.src = "/api/placeholder/400/300";
                    }}
                  />
                ) : (
                  <div className="alert alert-warning">Image not available</div>
                )}
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={closeImageModal}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WithdrawHistory;
